import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'

import AuthReducer from './Auth/AuthReducer';
import LoadingReducer from './Loading/LoadingReducer';
import ToastReducer from './Toast/ToastReducer';
import TrafficReducer from './Traffic/TrafficReducer';
import RecipeReducer from './Recipe/RecipeReducer';
import AiGenReducer from './AiGen/AiGenReducer';

const initionState = {}
const middleware = [thunk]
const rootReducer = combineReducers({
    auth: AuthReducer,
    loading: LoadingReducer,
    toast: ToastReducer,
    traffic: TrafficReducer,
    recipe: RecipeReducer,
    aiGen:AiGenReducer
})

const Store = createStore(rootReducer, initionState, composeWithDevTools(applyMiddleware(...middleware)));
// const store = createStore(rootReducer, initionState, applyMiddleware(...middleware))

export default Store